import {call, put} from 'redux-saga/effects';
import ApiService from 'api/ApiService';
import api from 'api';
import {layoutActions} from 'features/layout/redux';
import {DialogTypes} from 'common/names';
import i18n from 'i18next';
import {Action} from 'redux/helpers';

export function* releaseSaga({payload}: Action) {
   try {
      yield call(ApiService.postSecureJson, api.releaseObject, JSON.stringify(payload));
      yield put(
         layoutActions.openSubDialog({
            id: DialogTypes.AlertDialog.id,
            title: i18n.t('Release Suspensions Status'),
            content: i18n.t('Suspension(s) released'),
         })
      );
      yield put(layoutActions.loadTreeNav());
   } catch (e) {
      console.debug(e);
   }
}

export function* suspendSaga({payload}: Action) {
   try {
      yield call(ApiService.postSecureJson, api.suspendObject, JSON.stringify(payload));
      yield put(
         layoutActions.openSubDialog({
            id: DialogTypes.AlertDialog.id,
            title: i18n.t('Suspension Status'),
            content: i18n.t('Suspension(s) set'),
         })
      );
      yield put(layoutActions.loadTreeNav());
   } catch (e) {
      console.debug(e);
   }
}
